import React from 'react';
import PropTypes from 'prop-types';
import ExpandableListItemContainer from 'containers/ExpandableListItemContainer/ExpandableListItemContainer';
import { buildFaqStructuredData } from 'utils/StructuredData';
import classes from './ExpandableList.module.scss';

const {
  arrayOf,
  string,
  shape,
  object,
  oneOfType,
  bool,
} = PropTypes;

const ExpandableList = (props) => {
  const { items = [], type, renderStructuredData = true, heading, ...rest } = props;

  if (items.length === 0) {
    return null;
  }

  const list = items.map((item, idx) => {
    const {
      title,
      body,
    } = item;

    return <ExpandableListItemContainer type={type} title={title} body={body} key={idx} {...rest} />;
  });

  return (
    <div>
      {heading && <div className={classes.heading}>{heading}</div>}
      {renderStructuredData &&
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: buildFaqStructuredData(items) }}
        />}
      {list}
    </div>
  );
};

ExpandableList.propTypes = {
  /**
   * Expandable List Type<br>
   * Options: `ExpandableListItemA` `ExpandableListItemB` `ExpandableListItemC` `ExpandableListItemD`
  */
  type: string.isRequired,
  /**
   * Expandable List Heading
   */
  heading: string,
  /**
   * A list of item objects
  */
  items: arrayOf(shape({
    title: string,
    body: oneOfType([
      string,
      object,
    ]),
  })),
  /**
   * Render Structured Data
  */
  renderStructuredData: bool,
};

export default ExpandableList;
